import { useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { captureException } from '@sentry/nextjs';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useUpdateCoachAboutMutation } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';
import CloseIcon from 'svg/CloseIcon';
import Button, { ButtonText } from 'components/Button';
import InputField from 'components/coaches-builder/InputField';
import { InputType } from 'components/coaches-builder/InputField/InputField';
import ProfileItem from 'components/coaches-builder/ProfileItem';
import Modal from 'components/modals/Modal';
import { aboutMeSchema } from './schemas';
import { FormModalProps } from '../types';

interface AboutMeFormModalProps extends FormModalProps {}

type AboutMeSchemaType = z.infer<typeof aboutMeSchema>;

const AboutMeFormModal: React.FC<AboutMeFormModalProps> = ({
  isOpen,
  handleClose,
  coachData,
  mode,
}) => {
  const {
    register,
    setValue,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm<AboutMeSchemaType>({
    resolver: zodResolver(aboutMeSchema),
  });

  const [updateCoachAbout, { loading: UpdateCoachAboutLoading }] = useUpdateCoachAboutMutation();

  const viewer = useViewer();

  const onSubmit = async (data: AboutMeSchemaType) => {
    try {
      await updateCoachAbout({
        variables: {
          aboutMe: data.aboutMe,
          userId: viewer.userId,
        },
      });
      handleClose(true);
    } catch (err) {
      captureException(err);
    }
  };

  useEffect(() => {
    // if (mode === FormModalModeEnum.Add) {
    //   reset();
    //   return;
    // }
    if (!coachData?.aboutMe) return;
    setValue('aboutMe', coachData.aboutMe);
  }, [coachData, reset, setValue, mode]);

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} classNameMaxWidth="max-w-[80vw]">
      <div className="flex items-center justify-between border-b px-8 py-4">
        <h2 className="typography-product-heading-desktop">About me</h2>
        <ButtonText onClick={() => handleClose()}>
          <CloseIcon className="h-4 w-4" />
        </ButtonText>
      </div>
      <div className="flex flex-col px-4 md:px-10">
        <ProfileItem
          label="About me"
          description="Introduce yourself and explain how you get into coaching pickleball."
          component={
            <InputField
              fieldLabel="aboutMe"
              errors={errors}
              placeholder="Tell more about yourself"
              name="aboutMe"
              register={register}
              inputType={InputType.Textarea}
            />
          }
          hasBottomBorder={false}
        />
      </div>
      <div className=" flex justify-end border-t px-8 py-4">
        <Button
          disabled={UpdateCoachAboutLoading}
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          className="w-fit"
          size="lg"
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default AboutMeFormModal;
